import * as API from '@siloreal:shared:api';

const ORGANIZATION_SELECTABLE_LIST_ENDPOINT = '/user_organizations';

export type OrganizationSelectableListServiceContract = {
  signal?: AbortSignal;
};

export async function listSelectableOrganizationsService(
  contract: OrganizationSelectableListServiceContract = {}
): Promise<OrganizationSelectableListResponse> {
  const { data } = await API.http.fetch.get<OrganizationSelectableListApiResponse>(
    ORGANIZATION_SELECTABLE_LIST_ENDPOINT,
    {
      signal: contract.signal,
    }
  );

  return toOrganizationSelectableListResponse(data);
}

export type OrganizationSelectableListResponse = OrganizationSelectableListItem[];

type OrganizationSelectableListApiResponse = OrganizationSelectableListResponse | string;

export type OrganizationSelectableListItem = {
  id: number;
  name: string;
};

function toOrganizationSelectableListResponse(
  data: OrganizationSelectableListApiResponse
): OrganizationSelectableListResponse {
  const normalizedData = typeof data === 'string' ? JSON.parse(data) : data;

  return Array.isArray(normalizedData) ? (normalizedData as OrganizationSelectableListResponse) : [];
}
